// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1588":"8f2c0259","3649":"8f2c0259","4445":"35638453","8092":"96d5931a"}[chunkId] + ".chunk.css";
};